module.exports = __webpack_public_path__ + "static/img/WarmPlate (17).ff97cf33.png";